import { useCreateField } from '../hooks'
import type { FieldType, FormSection } from '../types'

/**
 * Adds a presentational field (SEPARATOR / SPACER) directly without a dialog.
 * Generates a unique fieldCode based on timestamp to avoid the "already exists"
 * conflict. Defaults differ per type:
 *   - SEPARATOR: full row, no label by default (admin can edit later)
 *   - SPACER: half-row by default
 */
export function useAddPresentationalField(objectType: string) {
  const create = useCreateField(objectType)

  return {
    isPending: create.isPending,
    add: (type: 'SEPARATOR' | 'SPACER' | 'INSTRUCTION' | 'HEADER', section: FormSection) => {
      const ts = Date.now()
      const codePrefix =
        type === 'SEPARATOR' ? 'sep' :
        type === 'SPACER' ? 'space' :
        type === 'HEADER' ? 'head' : 'info'
      const code = `${codePrefix}_${ts}`
      const defaultLabel =
        type === 'HEADER' ? 'Nagłówek sekcji' :
        type === 'INSTRUCTION' ? '—' : '—'
      create.mutate({
        fieldCode: code,
        sectionCodes: [section.code],
        // Backend wymaga niepustego labelPl; '—' to placeholder dla typów bez tytułu.
        // HEADER ma sensowny domyślny tekst, który admin nadpisze.
        labelPl: defaultLabel,
        fieldType: type as FieldType,
        isRequired: false,
        isFilterable: false,
        validation: null,
        options: null,
        referenceTable: null,
        helpText: type === 'INSTRUCTION' ? 'Treść instrukcji - edytuj w ustawieniach pola.' : null,
        isActive: true,
      })
    },
  }
}
